import React, { Component } from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFacebookSquare,
    faTwitterSquare,
    faInstagram,
    faYoutubeSquare
} from "@fortawesome/free-brands-svg-icons";

// Todo: get the data dynamically and move this to a file
//import { getSocialData } from './social-bar-fn';
import { getFontSize } from './social-bar-fn'
import "./social-bar.scss";

library.add(faFacebookSquare, faTwitterSquare, faInstagram, faYoutubeSquare);

//var socialData = getSocialData();
var fontClass = getFontSize();

function SocialBar() {
    return (
        <div className="social-bar">
            <a
                key="facebook"
                href="https://www.facebook.com/wesaltythree"
                target="_blank"
                rel="noopener noreferrer"
            >
                <FontAwesomeIcon
                    className={fontClass}
                    icon={["fab", "facebook-square"]}
                />
            </a>
            <a
                key="instagram"
                href="https://instagram.com/wesaltythree"
                target="_blank"
                rel="noopener noreferrer"
            >
                <FontAwesomeIcon
                    className={fontClass}
                    icon={["fab", "instagram"]}
                />
            </a>
            <a
                key="twitter"
                href="https://www.twitter.com/wesaltythree"
                target="_blank"
                rel="noopener noreferrer"
            >
                <FontAwesomeIcon
                    className={fontClass}
                    icon={["fab", "twitter-square"]}
                />
            </a>
            {/* <a
                key="youtube"
                href="https://www.youtube.com/channel/UCB5rsGG7OQgWRLbygls0jKQ"
                target="_blank"
                rel="noopener noreferrer"
            >
                <FontAwesomeIcon
                    className={fontClass}
                    icon={["fab", "youtube-square"]}
                />
            </a> */}
        </div>
    );
}

export default SocialBar;